import { coreAxios } from '@/declare/api/axios'
import { File } from '@/declare/interface/project/file'
import { AxiosResponse } from "axios"
import qs from 'qs'

/**
 * 添加一个文件
 * @param projectUuid 
 * @param file 
 * @param params 
 * @returns 
 */
export function addFile(projectUuid: string, file: File, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/files`, file, {
        params: {
            ...params
        }
    })
}

/**
 * 添加多个文件
 * @param projectUuid 
 * @param fileList 
 * @param params 
 * @returns 
 */
export function addFileList(projectUuid: string, fileList: File[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/files-multiple`, fileList, {
        params: {
            ...params
        }
    })
}

/**
 * 根据项目id与类型组获取带有层级的文件列表
 * @param projectUuid 
 * @param types 
 * @param params 
 * @returns 
 */
export function findFileMapByProjectUuidAndTypes(projectUuid: string, types: number[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/files/types`, {
        params: {
            ...params,
            types: types
        }, paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

/**
 * 更新文件
 * @param fileUuid 
 * @param file 
 * @param params 
 * @returns 
 */
export function updateFile(fileUuid: string, file: File, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/files/${fileUuid}`, file, {
        params: {
            ...params
        }
    })
}

export function findFileListByParentUuidList(projectUuid: string, parentUuidList: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/files-parent/files`, {
        params: {
            ...params,
            parentUuidList: parentUuidList
        },
    })
}
/**
 * 获取文件路径
 * @param fileUuid 
 * @param params 
 * @returns 
 */
export function getFilePathByFileUuid(fileUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/files/${fileUuid}/path`, {
        params: {
            ...params
        }
    })
}

/**
 * 根据uuid列表删除文件
 * @param fileUuidList 
 * @param params 
 * @returns 
 */
export function deleteFileByUuidList(fileUuidList: string[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/files/files-multiple`, {
        params: {
            ...params,
            deleteUuidList: fileUuidList
        }, paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

/**
 * 根据uuid查询文件详情
 * @param fileUuid 
 * @param params 
 * @returns 
 */
export function findFileByUuid(fileUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/files/${fileUuid}`, {
        params: {
            ...params,
        }
    })
}

/**
 * 根据项目uuid查询文件列表
 * @param projectUuid 
 * @param params 
 * @returns 
 */
export function findFileByProjectUuid(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/files`, {
        params: {
            ...params,
        }
    })
}

/**
 * 根据项目uuid获得某个专业的文件
 * @param projectUuid
 * @param params 
 * @returns 
 */
export function getMajorFileByProjectUuid(projectUuid: string, majorUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/majors/${majorUuid}`, {
        params: {
            ...params
        }
    })
}

